<script setup>
    import axios from 'axios';
    import Swal from 'sweetalert2';

    const props = defineProps(['fetchUrl']);

    function generateFiles() {
        axios.post(props.fetchUrl).then((response) => {
            if (response) {
                Swal.fire({
                    title: "Erfolgreich",
                    text: response.data.message,
                    icon: 'success',
                }).then((result) => {
                    if (result.isConfirmed === true) {
                        window.location.reload();
                    }
                });
            }
        }).catch(error => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            });
        })
    }

</script>

<template>
    <button @click.prevent="generateFiles()" class="btn btn-primary">
        <i class="fa-solid fa-file-csv"></i> Abrechnungsdateien erstellen
    </button>
</template>
